<ms-outrights-marquee
    *ngIf="!hidden"
    [fixture]="fixture"
    [backgroundContainerConfig]="backgroundContainerConfig"
    [globalLinkConfig]="globalLinkConfig"
    [maxSelection]="maxSelection">
</ms-outrights-marquee>
